import { create } from 'zustand';

interface AIWeaverState {
  isOpen: boolean;
  toggle: () => void;
}

export const useAIWeaverStore = create<AIWeaverState>((set) => ({
  isOpen: false,
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
